export default {
    carregando: true,
    items: [],
    selecionado: {},
    fichaTecnica: [],
    fichaTecnicaTarefa: [],
    httpStatusCode: '',
    historicoFichaTecnica: {
        per_page: 10,
        data: [],
        current_page: 1,
        last_page: ''
    },
    historicoTicket: null,
    carregandoOpcoesTratativas: false,
    opcoesTratativasTarefas: [],
    dadosAdocao: {},
    carregandoDadosHistorico: false,
    tarefas: {
        per_page: 10,
        data: [],
        current_page: 1,
        last_page: ''
    },
    carregandoPcoTarefas: false,
    listaTratativas: []
}